import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M10 20H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H20a2 2 0 0 1 2 2v2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "16", cy: "20", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 14-4.5 4.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m21 15 1 1", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderKey";
const FolderKey = memo(themed(Icon));
export {
  FolderKey
};
//# sourceMappingURL=folder-key.js.map
